import React from "react";
import './VideoComponent.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from "react-router-dom";

export default function VideoComponent({ patientName, patientImage, alt, onClick, patientId,className }) {
    
            return (
                <div className={`${patientId}`}>
                    <Link onClick={onClick}>
                        <LazyLoadImage
                            alt={alt}
                            className={`img-fluid ${className}`}
                            src={patientImage}
                        />
                        <div className="symptom-video-patient-name show_desktop">
                            <div className="symptom-video-patient-image" >
                                <div className="video-button"></div>
                                <span >{patientName}</span>
                            </div>
                        </div>
                        <div className="symptom-video-patient-name show_mobile">
                            <div className="symptom-video-patient" >
                                <img src="/assets/images/Group 137.webp" className={`video-play-button`} />
                                <span >{patientName}</span>
                            </div>
                        </div>
                    </Link>
                </div>
            )
        }